import {UPDATE_MODAL, UPDATE_PRESENTATION_QR_MODAL} from '../actions/modal.actions';
import {ModalReducerType} from '../actions/types/modal.actions.types';

export interface ModalReducerState {
    modalVisible: boolean;
    modalSlideId: string;
    clickToDisplay: string[];
    isPresentationQrModalOpen: boolean;
}

export const preloadedState: ModalReducerState = {
    modalVisible: false,
    modalSlideId: '',
    clickToDisplay: [],
    isPresentationQrModalOpen: false,
};

export const modalReducer = (state: ModalReducerState = preloadedState, action: ModalReducerType): ModalReducerState => {
    switch (action.type) {
        case UPDATE_MODAL:
            return {
                ...state,
                modalVisible: action.payload.modalVisible,
                modalSlideId: action.payload.slideId,
                clickToDisplay: action.payload.clickToDisplay,
            };
        case UPDATE_PRESENTATION_QR_MODAL:
            return {
                ...state,
                isPresentationQrModalOpen: action.payload,
            };
        default:
            return state;
    }
};
